module.exports = __webpack_public_path__ + "img/waitingconfmseller.c7c6ba7a.png";